export default __webpack_public_path__ + "static/media/bg-mapa.26bd5dab.webp";